// PHA-1168 Reports: page chrome for the Reports list, run page and report
// builder. Deliberately not ClinicLayout: that frames pages as Clinic Settings
// and is admin-only, while any user of an org with reports can run them.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Flex, Heading, Text } from '@radix-ui/themes';
import { ArrowLeftIcon } from '@radix-ui/react-icons';
import OrganizationSelector from '../OrganizationSelector';

interface ReportsLayoutProps {
  title: string;
  subtitle?: string;
  /** Where the back arrow goes; defaults to the Reports list (a billing-page report: /billing). */
  backTo?: string;
  children: React.ReactNode;
}

const ReportsLayout: React.FC<ReportsLayoutProps> = ({ title, subtitle, backTo = '/reports', children }) => {
  const navigate = useNavigate();
  return (
    <Box className="min-h-screen bg-slate-1">
      <Box className="border-b border-slate-6 bg-white sticky top-0 z-50">
        <Container size="4">
          <Flex align="center" justify="between" py="3" wrap="wrap" gap="3">
            <Flex align="center" gap="3">
              <Button variant="ghost" onClick={() => navigate(backTo)} aria-label={backTo === '/' ? 'Back to dashboard' : backTo === '/billing' ? 'Back to billing' : 'Back to reports'}>
                <ArrowLeftIcon />
              </Button>
              <Heading size="6" className="text-slate-800">Reports</Heading>
            </Flex>
            <Flex align="center" gap="2" wrap="wrap">
              <OrganizationSelector />
              <Button variant="soft" onClick={() => navigate('/')}>Dashboard</Button>
            </Flex>
          </Flex>
        </Container>
      </Box>

      <Container size="4" className="py-6">
        <Flex direction="column" gap="1" className="mb-5">
          <Heading size="5" className="text-slate-800">{title}</Heading>
          {subtitle && <Text size="2" color="gray">{subtitle}</Text>}
        </Flex>
        {children}
      </Container>
    </Box>
  );
};

export default ReportsLayout;
